import { getUA } from './getUA'
import { isBrowser } from './isBrowser'

export type DeviceTypes<T> = {
  pc?: T
  ios?: T
  android?: T
  sp?: T
}

interface DeviceAdapter {
  <T, U extends DeviceTypes<T>>(types: U, fallback: T): T
  <T, U extends Required<DeviceTypes<T>>>(types: U): T
}
/**
 * デバイスごとに出し分ける場合に使う
 */
/* eslint-disable complexity */
export const deviceAdapter: DeviceAdapter = <T, U extends DeviceTypes<T>>(
  device: U,
  fallback?: T
): T | undefined => {
  if (!isBrowser) return fallback

  const ua = getUA()
  if (ua.Mobile && ua.iOS) return device.ios ?? fallback
  if (ua.Mobile && ua.Android) return device.android ?? fallback
  if (ua.Mobile) return device.sp ?? fallback
  return device.pc ?? fallback
}
